import type { CellContext, ColumnHelper } from '@tanstack/react-table';

import { SourceResourceCell } from './SourceResourceCell';

export const sourceResourceAccessor = <
  T extends { sourceResourceDisplayName?: string; sourceResourceId: string; sourceResourceName: string },
>(
  columnHelper: ColumnHelper<T>,
  templates?: string[],
  canFollowLink = false,
) =>
  columnHelper.accessor((entity) => entity.sourceResourceDisplayName, {
    id: 'sourceResourceDisplayName',
    header: 'Template',
    filterFn: 'arrIncludesSome',
    size: 216,
    cell: (cellContext: CellContext<T, string>) => (
      <SourceResourceCell
        name={cellContext.getValue()}
        sourceResourceId={cellContext.row.original.sourceResourceId}
        sourceResourceName={cellContext.row.original.sourceResourceName}
        canFollowLink={canFollowLink}
      />
    ),
    meta: {
      filter: {
        placeholder: 'All templates',
        options: templates,
      },
    },
  });
